"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
var lib_1 = require("../lib");
namespace_1.default.namespace.extend('utils', {
    /*
        creates a pseudo-unique id
        
        @param defines the character-length of the id (default = 8). Character-length has to be a multiple of 4
    */
    uniqId: function (chars) {
        var tCount = chars ? chars / 4 : 2;
        var uid = '';
        var getRandom = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        for (var i = 0; i < tCount; i++) {
            uid += getRandom();
        }
        return uid;
    },
    /*
        Returns the number of elements in an object.
        
        @param obj is the JSON-Object we want to have the size of.
        @returns the size of the JSON-Object.
    */
    getObjectSize: function (obj) {
        var size = 0;
        var key;
        for (key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key))
                size++;
        }
        return size;
    },
    isEmptyObject: function (obj) {
        if (Object.keys(obj).length === 0 && obj.constructor === Object)
            return true;
        return false;
    },
    extend: lib_1.extend,
    extendDeep: lib_1.extendDeep,
});
